import ResolveError from "./ResolveError.mjs";
class MaximumResolveDepthError extends ResolveError {}
export default MaximumResolveDepthError;